import { parseVersion } from '@amazon/vinyl-util'

declare global {
    var version: string
}

export const bullfrogVersion = parseVersion(process.env.BULLFROG_VERSION ?? '0.0.0.0')
global.version = bullfrogVersion.str
